import React, { useState } from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { withStyles } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core';

const BlueCheckbox = withStyles({
    root: {
        '&$checked': { color: '#1094F7' },
        width: '20px',
        height: '20px',
        marginRight: '14px',
    },
    checked: {
        color: '#1094F7',
    },
})((props) => <Checkbox color="default" {...props} />);

const useStylesLabel = makeStyles(() => ({
    start: {
        alignItems: 'start',
        marginTop: '2px !important',
        marginBottom: '24px',
    },
    center: {
        alignItems: 'center',
        marginTop: '2px !important',
        marginBottom: '24px',
    },
}));

const useStylesCheckbox = makeStyles(() => ({
    red: {
        color: '#F90000',
    },
    grey: {
        color: '#8692A6',
    },
}));

export default function AuthorizationCheckbox({
    saveCheckbox,
    value,
    errorCheckbox,
    label,
    required,
    position,
}) {
    const [checked, setChecked] = useState(value);
    const handleChange = (event) => {
        setChecked(event.target.checked);
        saveCheckbox(event.target.checked);
    };
    const labelStyles = useStylesLabel();
    const checkboxStyles = useStylesCheckbox();

    return (
        <FormControlLabel
            control={
                <BlueCheckbox
                    checked={checked}
                    onChange={handleChange}
                    classes={{
                        root: errorCheckbox && required ? checkboxStyles.red : checkboxStyles.grey,
                    }}
                    name="checked"
                    color="primary"
                    inputProps={{
                        'data-id': 'register-checkbox',
                    }}
                />
            }
            className={position === 'start' ? labelStyles.start : label.top}
            label={label}
        />
    );
}
